export default "__VITE_ASSET__vFxyc7yH__"